import React, { useEffect, useState, useRef, useLayoutEffect } from "react";

/** Components */
import { Button, Tab, Tabs, Typography, Box, Tooltip, ButtonGroup, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { DeleteDialog } from "../../commons/dialog.component";
import EditIcon from "@mui/icons-material/Edit";
import CustomDatePicker from "../../commons/CustomDatePicker";
import CIListInvs from "./cilistinvs.component";
import PaymentNoticeViewer from "./paymentNoticeViewer.component";
import CommercialInvoiceViewer from "./commercialInvoiceViewer.component";

/** Icon */
import FilePresentIcon from "@mui/icons-material/FilePresent";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";

/** Functions */
import { deleteCI, getSingleCI, getCIZip, updateCI, createCIZip } from "./../../../services/api";

/** Hook */
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";
import dayjs from "dayjs";
import { useHistory, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function InvoiceViewer({ data = "", onCIProductChange, idParams, allowPrint = true, rightButton = undefined, deleteResponse, onCheckboxOnTable, onCheckAll }) {
  /** Hook */
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const ref = useRef();

  /** State */
  const [dataState, setDataState] = useState("");
  const [isUserClickPrintButton, setIsUserClickPrintButton] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);

  /**
   * Tab title
   * 0: Commercial Invoice - USD
   * 1: Payment Notice - VND
   * 2: Proforma Invoice - USD
   */
  const [tabTitle, setTabTitle] = useState("");

  const handleDeleteAction = () => {
    return deleteCI(idParams);
  };
  const handleDeleteResponse = (res) => {
    deleteResponse && deleteResponse(res, idParams);
    if (res.code === 200) {
      setDataState((prev) => ({ ...prev, status: 4 }));
    }
  };
  const handleEditResponse = (res) => {
    fetchData();
  };

  const handleCreateCiZip = (res) => {
    createCIZip(idParams).then((res) => {
      enqueueSnackbar(res.message);
    });
  };

  const handleDownloadZip = () => {
    getCIZip(idParams).then((res) => {
      if (res.code !== 200) {
        enqueueSnackbar(res.message);
        return;
      }
      const a = document.createElement("a");
      a.href = res.data;
      a.download = "file.rar";
      a.click();
    });
  };
  const handlePrint = useReactToPrint({
    content: () => ref.current,
  });

  const [tab, setTab] = useState(0);
  const fetchData = () => {
    if (idParams)
      getSingleCI(idParams).then((res) => {
        if (res.code === 200) {
          setDataState({ ...res.data });
        } else history.replace(`/ci${location.search}`);
      });
  };

  useEffect(() => {
    fetchData();
    // neu duoc truyen id thi gui request len sv de lay du lieu ve, roi nhet vao state data
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idParams]);
  useEffect(() => {
    if (!data) return;
    setDataState(data);
  }, [data]);
  useLayoutEffect(() => {
    if (isUserClickPrintButton) {
      handlePrint();
      setIsUserClickPrintButton(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUserClickPrintButton]);

  /**
   * Tab title
   * 0: Commercial Invoice - USD
   * 1: Payment Notice - VND
   * 2: Proforma Invoice - USD
   */
  useEffect(() => {
    switch (dataState.type) {
      case 0:
        setTabTitle("Commercial Invoice");
        break;
      case 1:
        setTabTitle("Thông báo thu tiền hàng");
        break;
      case 2:
        setTabTitle("Proforma Invoice");
        break;
      case 3:
        setTabTitle("Commercial Invoice");
        break;
      default:
        break;
    }
  }, [dataState.type]);

  if (dataState)
    return (
      <div>
        <div style={{ display: "flex", backgroundColor: "#b3deff", positon: "relative", justifyContent: "center", alignItems: "center" }}>
          <Tabs value={tab} style={{ maxWidth: "60%" }}>
            <Tab label={tabTitle} onClick={() => setTab(0)}></Tab>
            {/* <Tab label={dataState.type === 0 ? "Commercial invoice" : "Thông báo thu tiền hàng"} onClick={() => setTab(0)}></Tab> */}
            {dataState.ciproducts
              ?.filter((i) => i.isCreateBK !== false)
              .map((item, index) => (
                <Tab key={index} label={`BK.${index + 1}`} onClick={() => setTab(index + 1)} />
              ))}
          </Tabs>
          {allowPrint && !rightButton ? (
            <ButtonGroup style={{ position: "absolute", height: 48, right: 0 }}>
              {dataState.status !== 4 && (
                <Button onClick={() => setIsEditDialogOpen(true)}>
                  <EditIcon />
                </Button>
              )}
              <EditCIDialog key={Boolean(isEditDialogOpen)} onResponse={handleEditResponse} open={isEditDialogOpen} onClose={() => setIsEditDialogOpen(false)} ciData={dataState} />
              <Button title={t("Tạo file zip tổng hợp")} onClick={handleCreateCiZip}>
                <FilePresentIcon />
              </Button>
              {dataState.zip_path && (
                <Button title={t("Tải toàn bộ phiếu dầu/HĐ GTGT")} onClick={handleDownloadZip}>
                  <DownloadIcon />
                </Button>
              )}
              {dataState.status !== 4 && (
                <Tooltip title="Huỷ">
                  <ButtonWithAPICall variant="outlined" api={handleDeleteAction} dialogNode={(params) => <DeleteDialog {...params} />} response={handleDeleteResponse}>
                    <DeleteIcon />
                  </ButtonWithAPICall>
                </Tooltip>
              )}
              <Button title={t("In thông báo thu tiền/ bảng kê")} color="primary" style={{ marginRight: "10px" }} onClick={() => setIsUserClickPrintButton(true)}>
                <PrintIcon />
              </Button>
            </ButtonGroup>
          ) : (
            rightButton
          )}
        </div>
        <TabPanel value={tab} index={0}>
          <div ref={ref}>
            <style type="text/css" media="print">
              {" @page { size: A4 landscape; } "}
              {" body { zoom: 70%; } "}
            </style>
            {/* type: 0 - CI, 1: PN */}
            {dataState.type === 1 ? (
              <PaymentNoticeViewer data={dataState} onCheckbox={onCheckboxOnTable} onCheckAll={onCheckAll} onChange={onCIProductChange} />
            ) : (
              <CommercialInvoiceViewer data={dataState} onCheckbox={onCheckboxOnTable} onCheckAll={onCheckAll} onChange={onCIProductChange} isPrint={isUserClickPrintButton} />
            )}
          </div>
        </TabPanel>
        {tab !== 0 && (
          <div ref={ref}>
            <CIListInvs
              ciData={dataState?.ciproducts?.filter((i) => i.isCreateBK !== false)?.[tab - 1]}
              tableData={{
                ...dataState,
                invoices: dataState.invoices.filter((invoice) => JSON.parse(dataState.ciproducts.filter((i) => i.isCreateBK !== false)[tab - 1]?.invoices)?.includes(invoice.id)),
              }}
            />
          </div>
        )}
      </div>
    );
  else return "";
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const EditCIDialog = ({ open, ciData, onClose, onResponse }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState({
    code: "",
    effective_time: "",
    end_effective_time: "",
  });
  const handleSave = () => {
    return updateCI(ciData.id, input);
  };
  const handleResponse = (res) => {
    // eslint-disable-next-line eqeqeq
    if (res.code == 200) {
      onClose?.();
      onResponse?.();
    }
  };
  useEffect(() => {
    setInput({
      code: ciData.code,
      effective_time: ciData.effective_time,
      end_effective_time: ciData.end_effective_time,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const diffDay = dayjs(ciData?.end_effective_time).diff(ciData?.effective_time, "days");
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Sửa thông tin CI/PN</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <TextField fullWidth label={t("Số CI/PN")} value={input.code} onChange={(e) => setInput((prev) => ({ ...prev, code: e.target.value }))} style={{ margin: "5px 0" }} />
        <CustomDatePicker
          sx={{ width: "100%", margin: "5px 0" }}
          label={t("Ngày hiệu lực")}
          value={input.effective_time}
          onChange={(value) => setInput((prev) => ({ ...prev, effective_time: value, end_effective_time: dayjs(value).add(diffDay, "days").format("YYYY-MM-DD") }))}
        />
        <CustomDatePicker
          disabled
          sx={{ width: "100%", margin: "5px 0" }}
          label={t("Ngày hết hạn")}
          value={input.end_effective_time}
          onChange={(value) => setInput((prev) => ({ ...prev, end_effective_time: value }))}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICall variant="contained" api={handleSave} response={handleResponse}>
          {t("Lưu")}
        </ButtonWithAPICall>
      </DialogActions>
    </Dialog>
  );
};
